import React, { useState, useEffect } from 'react';
import { FaTimes, FaShieldAlt } from 'react-icons/fa';

const CookieConsent: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Показываем попап через небольшую задержку для лучшего UX
      const timer = setTimeout(() => {
        setShow(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-in slide-in-from-bottom duration-300">
      <div className="container mx-auto max-w-4xl">
        <div className="glass-strong rounded-3xl p-6 md:p-8 border border-white/20 shadow-2xl">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl flex items-center justify-center">
                <FaShieldAlt className="text-white text-2xl" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold mb-2 heading-font">Utilisation des Cookies</h3>
              <p className="text-gray-300 mb-4 leading-relaxed">
                Nous utilisons des cookies pour améliorer votre expérience sur notre site, analyser le trafic et personnaliser le contenu. 
                En continuant à naviguer, vous acceptez notre utilisation des cookies conformément à notre{' '}
                <a href="/cookies" className="text-cyan-400 hover:text-cyan-300 underline">
                  politique des cookies
                </a>.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleAccept}
                  className="px-6 py-3 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 rounded-xl font-semibold text-white hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300"
                >
                  J'accepte
                </button>
                <button
                  onClick={handleDecline}
                  className="px-6 py-3 glass rounded-xl font-semibold text-gray-300 hover:text-white hover:bg-white/10 transition-all duration-300"
                >
                  Refuser
                </button>
              </div>
            </div>
            <button
              onClick={handleDecline}
              className="flex-shrink-0 text-gray-400 hover:text-white transition-colors p-2"
              aria-label="Fermer"
            >
              <FaTimes className="text-xl" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

